import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Tooltip from 'components/common/Tooltip';

const styles = theme => ({
  badge: {
    display: 'inline-block',
    width: 16,
    height: 16,
    cursor: 'pointer',
    textAlign: 'center',
    fontWeight: 500,
    borderRadius: 4,
  },
  badgeColorPrimary: {
    color: theme.palette.primary[500],
    border: `1px solid ${theme.palette.primary[500]}`,
  },
  badgeColorActive: {
    color: theme.palette.active[500],
    border: `1px solid ${theme.palette.active[500]}`,
  },
  badgeColorFuture: {
    color: theme.palette.future[500],
    border: `1px solid ${theme.palette.future[500]}`,
  },
  badgeColorWhite: {
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
  },
  badgeGutterLeft: {
    marginLeft: 4,
  },
  badgeGutterRight: {
    marginRight: 4,
  },
});

const Badge = ({
  children,
  tooltipText,
  color,
  gutter,
  className,
  classes,
}) => {
  if (tooltipText) {
    return (
      <Tooltip
        className={classNames(className, {
          [classes.badgeGutterLeft]: gutter && gutter === 'left',
          [classes.badgeGutterRight]: gutter && gutter === 'right',
        })}
        content={
          <Typography>
            {tooltipText}
          </Typography>
        }
        placement="top"
      >
        <Typography
          variant="caption"
          className={classNames(classes.badge, {
            [classes.badgeColorPrimary]: color === 'primary',
            [classes.badgeColorActive]: color === 'active',
            [classes.badgeColorFuture]: color === 'future',
            [classes.badgeColorWhite]: color === 'white',
          })}
        >
          {children}
        </Typography>
      </Tooltip>
    );
  }
  return (
    <Typography
      variant="caption"
      className={classNames(classes.badge, className, {
        [classes.badgeColorPrimary]: color === 'primary',
        [classes.badgeColorActive]: color === 'active',
        [classes.badgeColorFuture]: color === 'future',
        [classes.badgeColorWhite]: color === 'white',
        [classes.badgeGutterLeft]: gutter && gutter === 'left',
        [classes.badgeGutterRight]: gutter && gutter === 'right',
      })}
    >
      {children}
    </Typography>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipText: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'active', 'future', 'white']),
  gutter: PropTypes.oneOf(['left', 'right']),
  classes: PropTypes.shape({
    badge: PropTypes.string.isRequired,
    badgeColorPrimary: PropTypes.string.isRequired,
    badgeGutterLeft: PropTypes.string.isRequired,
    badgeGutterRight: PropTypes.string.isRequired,
    badgeColorWhite: PropTypes.string.isRequired,
  }).isRequired,
};

Badge.defaultProps = {
  color: 'primary',
  gutter: null,
  tooltipText: null,
  className: '',
};

export default withStyles(styles)(Badge);



// WEBPACK FOOTER //
// ./src/components/common/Badge.js